import { render, staticRenderFns } from "./LineItemAddressSelect.vue?vue&type=template&id=ca96ee5c"
import script from "./LineItemAddressSelect.vue?vue&type=script&lang=js"
export * from "./LineItemAddressSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports